import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFullscreen = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M19 5.73c0-.4.33-.73.73-.73h5.02c.56 0 1.12.2 1.55.56.43.37.7.9.7 1.48v5.23a.73.73 0 1 1-1.47 0V7.04a.49.49 0 0 0-.19-.37.93.93 0 0 0-.6-.2h-5a.73.73 0 0 1-.74-.74ZM26.27 19c.4 0 .73.33.73.73v5.02A2.25 2.25 0 0 1 24.75 27h-5.02a.73.73 0 1 1 0-1.47h5.02a.79.79 0 0 0 .78-.79v-5c0-.41.33-.74.74-.74ZM5.73 19c.4 0 .74.33.74.73v5.02c0 .24.08.45.2.6.12.13.26.18.37.18h5.23a.73.73 0 0 1 0 1.47H7.04c-.58 0-1.11-.27-1.48-.7A2.4 2.4 0 0 1 5 24.75v-5.02c0-.4.33-.73.73-.73ZM5.6 5.6c.38-.39.9-.6 1.44-.6h5.23a.73.73 0 0 1 0 1.47H7.04a.57.57 0 0 0-.57.57v5.23a.73.73 0 0 1-1.47 0V7.04c0-.54.21-1.06.6-1.44Z"
	})
});
export { SvgFullscreen as ReactComponent };
